import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9cd2bcc4")

_pushScopeId("data-v-9cd2bcc4")
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Find me at:", -1)
const _hoisted_3 = { class: "links" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("ul", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (item) => {
        return (_openBlock(), _createBlock("li", {
          key: item.title
        }, [
          _createVNode("a", {
            href: item.url,
            alt: item.title,
            style: `--item-color: ${item.color};`,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createVNode("i", {
              class: item.icon
            }, null, 2)
          ], 12, ["href", "alt"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})